module.exports = __webpack_public_path__ + "img/直播场景_教育直播.81f399a7.png";